import { globalReducer } from '../../features/global'
import { applicationsReducer } from '../../features/applications'
import { tariffsReducer, comunidadesReducer } from '../../features/tariffs'
import { usersReducer } from '../../features/users'
import { combosReducer } from '../../features/combos'
import { guildUsersReducer } from '../../features/guild-users/slices'
import { marketerUsersReducer } from '../../features/marketer-users/slices'
import { marketerPotentialReducer } from '../../features/marketer-potential/slices'
import { administrativeLeavesReducer } from '../../features/administrative-leaves/slices'
import { ipReducer } from '../../features/ip/slices'
import { jcaReducer } from '../../features/jca/slices'
import { mailingConfigReducer } from '../../features/mailing-config/slices'
import { prescriptorInstallersReducer } from '../../features/prescriptor-installers/slices'

export const reduxReducer = {
  global: globalReducer,
  applications: applicationsReducer,
  comunidades: comunidadesReducer,
  tariffs: tariffsReducer,
  users: usersReducer,
  guildUsers: guildUsersReducer,
  marketerUsers: marketerUsersReducer,
  marketerPotential: marketerPotentialReducer,
  administrativeLeaves: administrativeLeavesReducer,
  ip: ipReducer,
  jca: jcaReducer,
  combos: combosReducer,
  mailingConfig: mailingConfigReducer,
  prescriptorInstallers: prescriptorInstallersReducer,
}
